import { centsToDollar } from 'core/Utils';
import { Text } from 'ui';

export const CampaignAmountRaised = ({ amount }: { amount?: number }) => {
  const amountRaised = centsToDollar(amount);
  return (
    <Text fz={{base: 'xs', xs: 'sm'}} fw={600} c="mint">
      {amountRaised || 0}
    </Text>
  );
};
